<template>
  <div>
    <modal-step v-if="currentStepKind && inModal" ref="modalStep">
      <template #body>
        <div class="step-container d-flex">
          <transition name="step-content">
            <component :is="currentStepComponent" v-if="currentStepKind" v-bind="stepData" :key="currentStepKind"
                       class="step-component" />
          </transition>
        </div>
      </template>
    </modal-step>
    <component :is="currentStepComponent" v-else-if="currentStepKind" v-bind="stepData" />
  </div>
</template>

<script>
import ModalStep from './shared/modal-step'
import { mapGetters, mapState } from 'vuex'

export default {
  components: { ModalStep },

  computed: {
    ...mapGetters('daisyChain', ['currentStepComponent']),
    ...mapState('daisyChain', ['currentStepKind', 'stepData']),

    inModal() {
      return this.currentStepKind !== 'redirect'
    }
  },

  watch: {
    currentStepKind() {
      // This is only executed once each time the step changes.
      if (this.$refs.modalStep) {
        // When modal contents are about to be changed for the new step, scroll modal to top
        this.$refs.modalStep.$el.scrollTop = 0
      }
    }
  },

  mounted() {
    this.$store.dispatch('daisyChain/loadStep')
  }
}
</script>

<style scoped lang="scss">
  @use "~common_styles/breakpoints" as breakpoints;

  .step-container {
    overflow: hidden;
  }

  .step-component {
    width: 100%;
    flex-shrink: 0;
  }

  // Starting start of enter
  .step-content-enter-from {
    opacity: 0;
  }

  // Depending on the width of the screen, the modal and its contents have different widths.
  // Since we slide the leaving content off by changing its margin below, that margin amount
  // to be transitioned also varies with the screen width.
  $transition-margin-xs: calc(58px - 100vw);
  $transition-margin-md: -458px;
  $transition-margin-lg: -534px;

  // Ending state of leave
  .step-content-leave-to {
    opacity: 0;

    margin-left: $transition-margin-lg; // Pulling the previous modal off to the left side so that the new one can take its position

    @include breakpoints.screen-md-down {
      margin-left: $transition-margin-md;
    }

    @include breakpoints.screen-xs-only {
      margin-left: $transition-margin-xs;
    }
  }

  .step-content-enter-active, .step-content-leave-active {
    transition: all .4s ease-in-out;
  }
</style>
